import React, { FC, useEffect } from 'react'
import { Layout } from 'components/Layout'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { ProductEditTemplate } from 'components/Templates'
import { getBread } from 'reducks/bread/selectors'
import { fetchBread } from 'reducks/bread/operations'
import { getBreadShortName } from 'lib/helper'

const ProductEdit: FC = () => {
  const dispatch = useDispatch()

  const path = useSelector((state: State) => state.router.location.pathname)
  const isEditPage = /\/product\/edit\/(?!.+\/)/.test(path)
  const id = isEditPage ? path.split('/product/edit/')[1] : undefined

  const bread = useSelector((state: State) => getBread(state))

  useEffect(() => {
    // 新規登録画面、またはすでに商品情報を取得済みの場合はrefetchしない
    if (!id || bread) return
    dispatch(fetchBread(id))
  }, [id, bread])

  return (
    <Layout
      title={bread ? `${getBreadShortName(bread)}の編集｜sacriで出品する商品の管理` : 'sacriで出品する商品の管理'}
    >
      <ProductEditTemplate isEditPage={isEditPage} />
    </Layout>
  )
}

export default ProductEdit
